export default "__VITE_ASSET__25554874__"